import { jsx as r } from "react/jsx-runtime";
import { useContext as d } from "react";
import { LocaleProvider as L, loadLangBundle as i } from "@systemeio/util";
import { LocaleProvider as s, loadLangBundle as u, getLocaleByLanguageCode as n, LocaleContext as m } from "@systemeio/ui";
import { useStore as g } from "../store/index.mjs";
const C = ({
  uiI18n: o,
  children: a,
  languageCode: e,
  utilI18n: t
}) => {
  const { setLocale: l } = g();
  return /* @__PURE__ */ r(
    L,
    {
      languageCode: e,
      i18n: t,
      loadLangBundle: i,
      children: /* @__PURE__ */ r(
        s,
        {
          onChange: (c) => l(n(c)),
          languageCode: e,
          i18n: o,
          loadLangBundle: u,
          children: a
        }
      )
    }
  );
}, P = () => {
  const o = d(m);
  if (!o)
    throw new Error("useLocaleContext must be used within a LocaleProvider");
  return { locale: n(o.currentLanguageCode), ...o };
};
export {
  C as LocaleProvider,
  P as useLocaleContext
};
